require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-emedicinehealth-living-with.json") })
        }
      }, "path---article-emedicinehealth-living-with");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-emedicinehealth-living-with!./.cache/json/article-emedicinehealth-living-with.json
// module id = 340
// module chunks = 231608221292675